export default __webpack_public_path__ + "static/media/OS_TienLen_CTY - ENG.660e256b.png";